import { render, staticRenderFns } from "./PlacesDrawer.vue?vue&type=template&id=4c97832b"
import script from "./PlacesDrawer.vue?vue&type=script&lang=js"
export * from "./PlacesDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports